import { Divider } from "antd";
import { useAppDispatch } from "core/utils";
import i18n from "i18next";
import { type FC, useState } from "react";

import type { FormJson } from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";
import { AppSchemaImportButton } from "src/app/features/ApplicationSchema/components/buttons/AppSchemaImportButton";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { SecondaryButton } from "../../../../components/Buttons/components/ActionButton";
import { showSuccessNotification } from "../../../../components/NotificationAlerts";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { useSaveAppSchemaMutation } from "../services/server/AppSchemaApi";

export interface ApplicationSchemaPageProps {}

export const ApplicationSchemaPage: FC<ApplicationSchemaPageProps> = () => {
    const dispatch = useAppDispatch();
    const [selectedFile, setSelectedFile] = useState<FormJson>();

    const [saveAppSchema] = useSaveAppSchemaMutation();
    const hasAccess = canAccess(ResourceName.APP_SCHEMA, "canRead");
    const canEdit = canAccess(ResourceName.APP_SCHEMA, "canWrite");

    const onSaveCallback = async () => {
        const result = await saveAppSchema(selectedFile as FormJson);
        const hasError = "error" in result;
        if (!hasError) {
            dispatch(
                showSuccessNotification({
                    text: i18n.t("common.formSaveSuccess", {
                        id: result.data.id,
                        resource: ResourceName.APP_SCHEMA.replace(/-/g, " "),
                    }),
                    autoCloseDisabled: false,
                }),
            );
        }
    };

    const importData = (importedData: FormJson) => {
        setSelectedFile(importedData);
    };

    return (
        <PageLayout>
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.appSchema" />
                    <Divider />
                    {canEdit ? (
                        <>
                            <SecondaryButton onClick={onSaveCallback} disabled={false}>
                                {i18n.t("common.schema")}
                            </SecondaryButton>
                            <AppSchemaImportButton onDataLoaded={importData} />
                        </>
                    ) : null}
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
